import {Action} from '../../actions';

export const ActionTypes = {
  FETCH_BSB_LOOKUP_PENDING: 'lookup/bsb/fetch_PENDING',
  FETCH_BSB_LOOKUP_FULFILLED: 'lookup/bsb/fetch_FULFILLED',
  FETCH_BSB_LOOKUP_REJECTED: 'lookup/bsb/fetch_REJECTED'
};

export interface FetchBsbLookupFulfilledPayload {
  bsbInfo: BsbLookupData[];
  statusCode?: number;
  message?: string;
}

export interface BsbLookupData {
  bsb: string;
  fiCode: string;
  fiName: string;
  bsbName: string;
  suburb: string;
  state: string;
  postcode: string;
}

export interface LookupBsbResponse {
  bsbInfo: BsbLookupData[];
  statusCode?: number;
  message?: string;
}

export interface ErrorResponse {
  response: {
    status: number;
    data: {
      err?: {
        errors?: {
          body?: {
            message?: string;
          };
        };
      };
    };
    statusText?: string;
  };
}

interface FetchBsbLookupAction {
  type: string;
}

interface FetchBsbLookupFulfilledAction extends Action<FetchBsbLookupFulfilledPayload> {
  type: string;
  payload: FetchBsbLookupFulfilledPayload;
}

export type BsbLookupActionTypes = FetchBsbLookupAction | FetchBsbLookupFulfilledAction;
